import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { EnvelopeRotate } from 'src/components/icons';
import DeleteInvitationFormModal from 'src/features/users/components/forms/DeleteInvitationFormModal';
import ResendInvitationFormModal from 'src/features/users/components/forms/ResendInvitationFormModal';
import { userMessages } from 'src/features/users/utils/messages';
import { Invitation } from 'src/features/users/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { ICON_MAP } from 'src/utils/constants';
import { generalMessages } from 'src/utils/messages';

export default function CellInvitationActions({ row }: CellContext<Invitation, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <ResendInvitationFormModal
                        selectedInvitation={row.original}
                        semantics={{ entryName: formatMessage(userMessages.invitation).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <EnvelopeRotate className="size-5" />
                            </Button>
                        </TooltipTrigger>
                    </ResendInvitationFormModal>
                    <TooltipContent>
                        <FormattedMessage {...userMessages.resendInvitation} />
                    </TooltipContent>
                </Tooltip>

                <Tooltip>
                    <DeleteInvitationFormModal
                        selectedInvitation={row.original}
                        semantics={{ entryName: formatMessage(userMessages.deleteInvitation).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteInvitationFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
